export const DOWNLOAD_FILE_PENDING = 'infomail/fileDownload/DOWNLOAD_FILE_PENDING';
export const DOWNLOAD_FILE_SUCCESS = 'infomail/fileDownload/DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_ERROR = 'infomail/fileDownload/DOWNLOAD_FILE_ERROR';
export const DOWNLOAD_FILE_RESET = 'infomail/fileDownload/DOWNLOAD_FILE_RESET';
